export default function parseForModelModifiers(modelModifiers, initialValue) {
  let parsedValue = initialValue;
  if (modelModifiers.uppercase) {
    parsedValue = parsedValue.toUpperCase();
  }
  return parsedValue;
}